/**
 * Summary Wrapper
 *
 * @package:  frictionlessdigital/dashboard
 * @version:  2.7
 * @return:   Controller
 */

import angular from 'angular';

angular.module('flsControllers').controller('SummaryController', ['$scope', function($scope){

    /**
     * Try to append all loaders here
     *
     * @type array
     */
    $scope.loaders = [];

    /**
     * Summary is driven in most cases by those; which we will pass to children
     *
     * @type {Object}
     */
    $scope.brand = null;
    $scope.from = null;
    $scope.to = null;

    /**
     * Init the Controller with the Context Ref string
     *
     * @param  {string} context_ref
     * @return {void}
     */
    $scope.init = function(brand, from = null, to = null) {
        $scope.brand = brand;
        $scope.from = from;
        $scope.to = to;
    }
}]);
